import { Context } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import ResetLocatorDialog from './ResetLocatorDialog';
import Util from './Util';
function isResettableLocator(item) {
  return !Util.locatorIsPendingReset(item.data) && Util.locatorMeetsFirmwareRequirements(item.data) && item.type === 'locator';
}
export default {
  id: 'recovr.locator.Reset',
  name: 'Reset Locator',
  layout: {
    sort: 'item.zzzzReset'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: ['locator', 'location.locators', 'company.locators', 'company.locations.locators'],
    objectType: 'locator'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  handles: cxt => {
    const targets = Context.getTargets(cxt);
    for (let i = 0; i < targets.length; i++) {
      if (isResettableLocator(targets[i])) {
        return true;
      }
    }
    return false;
  },
  appearance: ({
    context
  }) => {
    const targets = Context.getTargets(context);
    let name = 'Reset Locator';
    let numValidLocators = 0;
    for (let i = 0; i < targets.length; i++) {
      if (isResettableLocator(targets[i])) {
        numValidLocators++;
      }
    }
    if (numValidLocators > 1) {
      name = `Reset ${numValidLocators} Locators`;
    }
    return {
      name,
      icon: 'fa fa-refresh'
    };
  },
  perform: data => {
    const {
      context
    } = data;
    const targets = Context.getTargets(context);
    const locators = [];
    let numInvalidLocators = 0;
    for (let i = 0; i < targets.length; i++) {
      if (isResettableLocator(targets[i])) {
        locators.push(targets[i].data);
      } else {
        numInvalidLocators++;
      }
    }
    Dialogs.show({
      component: ResetLocatorDialog,
      props: {
        locators,
        numInvalidLocators
      }
    });
  }
};